import cx from "classnames";
import get from "lodash/get";
import { useCallback } from "react";
import { useRillContext } from "../../../../rill/RillReact/share/base";

function CalendarViewToggle({
  name,
  options,
  defaultActive,
  callback = () => {},
}) {
  const {
    locals: { query = {}, path },
  } = useRillContext();

  const active = defaultActive || get(query, name);

  const handleClick = useCallback(
    (value) => {
      callback(value);
    },
    [callback]
  );

  return (
    <ul role="toggle-links" className="calendar-view-toggle">
      <input type="hidden" name={name} value={active} />
      {options.map(({ value, text, href, IconImg = "" }) => {
        const searchString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        const newHref = href ? href : `/actions/refresh?${searchString}`;

        const isActive = href
          ? path === href || value === active
          : query[name]
            ? path.includes(searchString) || value === query[name]
            : value === active || path.includes(searchString);

        return (
          <a
            key={value}
            href={newHref}
            onClick={() => handleClick(value)}
            role="button"
            className={cx({ "value-active": isActive })}
          >
            {IconImg && (
              <span className="toggle-icon">{IconImg}</span>
            )}
            {text}
          </a>
        );
      })}
    </ul>
  );
}

export default CalendarViewToggle;
